import React from "react";

export default function SQLServer_SIN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_SIN</h1>
      <p>This is the SQLServer_SIN component generated from the SQL JSON.</p>
    </div>
  );
}
